// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {store} from './store/index'
import VueFuse from 'vue-fuse'

Vue.use(Treeselect)
Vue.use(VueFuse)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#shopsListWrap',
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js